import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import './DateTimeBanner.css';

const DateTimeBanner = () => {
  const [currentDate, setCurrentDate] = useState(new Date());

  // Update date once per day (no need to update every second for date only)
  useEffect(() => {
    const updateDate = () => {
      setCurrentDate(new Date());
    };

    // Update immediately
    updateDate();

    // Update at midnight each day
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    const msUntilMidnight = tomorrow.getTime() - now.getTime();

    const timeoutId = setTimeout(() => {
      updateDate();
      // Then update every 24 hours
      const intervalId = setInterval(updateDate, 24 * 60 * 60 * 1000);
      return () => clearInterval(intervalId);
    }, msUntilMidnight);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="datetime-banner" style={{
      background: 'linear-gradient(135deg, #bb86fc, #03dac6)',
      padding: '0.4rem 0',
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      width: '100%',
      zIndex: '9999',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
      display: 'block',
      visibility: 'visible'
    }}>
      <Container>
        <div className="datetime-content text-center" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'black',
          fontWeight: '600',
          fontSize: '1rem'
        }}>
          <span className="current-date">
            {currentDate.toLocaleDateString('en-US', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </span>
        </div>
      </Container>
    </div>
  );
};

export default DateTimeBanner;
